import { Link } from "react-router-dom";
import { ClipboardList, Settings, UserRound, WalletCards } from "lucide-react";

export default function AirtimeTopActions() {
  const linkClass =
    "inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-black text-slate-700 shadow-sm hover:bg-slate-50";

  return (
    <div className="flex flex-wrap gap-3">
      <Link to="/hr/airtime/config" className={linkClass}>
        <Settings className="h-4 w-4" />
        Config
      </Link>

      <Link to="/hr/airtime/allocations" className={linkClass}>
        <WalletCards className="h-4 w-4" />
        Allocations
      </Link>

      <Link to="/hr/airtime/my-airtime" className={linkClass}>
        <UserRound className="h-4 w-4" />
        My Airtime
      </Link>

      <Link to="/hr/airtime/batches" className={linkClass}>
        <ClipboardList className="h-4 w-4" />
        History
      </Link>
    </div>
  );
}